<style>
    .select2-container--default .select2-selection--single .select2-selection__arrow b {
        border-width: 0px 4px 0 4px;
        height: 25px;
        left: 0%;
    }
</style>
<template>
    <div class="row">
        <div class="col-12">
            <template v-if="letterStore.RECIPIENT.BUREAU == letter.recipient">
                <div
                    v-if="
                        reportStore.getSelectedAccounts(1, 'all').length > 0
                        ||
                        reportStore.getInquiries(1).length > 0
                        ||
                        reportStore.getSelectedAccounts(1, 'all', 'public-record').length > 0
                    "
                    class="card-body"
                >
                    <ul class="nav nav-tabs nav-justified" role="tablist">
                        <li
                            v-if="
                                reportStore.getSelectedAccounts(1, creditBureaus['TransUnion'].id).length > 0
                                ||
                                reportStore.getInquiries(1, 'TransUnion').length > 0
                                ||
                                reportStore.getSelectedAccounts(1, creditBureaus['TransUnion'].id, 'public-record').length > 0
                            "
                            class="nav-item"
                        >
                            <a
                                class="nav-link"
                                :class="{ active: activeTab == 'transUnion'}"
                                @click="activeTab = 'transUnion'"
                            >
                                TransUnion
                            </a>
                        </li>
                        <li
                            v-if="
                                reportStore.getSelectedAccounts(1, creditBureaus['Experian'].id).length > 0
                                ||
                                reportStore.getInquiries(1, 'Experian').length > 0
                                ||
                                reportStore.getSelectedAccounts(1, creditBureaus['Experian'].id, 'public-record').length > 0
                            " 
                            class="nav-item"
                        >
                            <a
                                class="nav-link"
                                :class="{ active: activeTab == 'experian'}"
                                @click="activeTab = 'experian'"
                            >
                                Experian
                            </a>
                        </li>
                        <li
                            v-if="
                                reportStore.getSelectedAccounts(1, creditBureaus['Equifax'].id).length > 0
                                ||
                                reportStore.getInquiries(1, 'Equifax').length > 0
                                ||
                                reportStore.getSelectedAccounts(1, creditBureaus['Equifax'].id, 'public-record').length > 0
                            "
                            class="nav-item"
                        >
                            <a
                                class="nav-link"
                                :class="{ active: activeTab == 'equifax'}"
                                @click="activeTab = 'equifax'"
                            >
                                Equifax
                            </a>
                        </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content pt-1">
                        <div
                            class="tab-pane active"
                            role="tabpanel"
                        >
                            <div
                                v-if="
                                    reportStore.getSelectedAccounts(1, creditBureaus['TransUnion'].id).length > 0
                                    ||
                                    reportStore.getInquiries(1, 'TransUnion').length > 0
                                    ||
                                    reportStore.getSelectedAccounts(1, creditBureaus['TransUnion'].id, 'public-record').length > 0
                                "
                                v-show="activeTab == 'transUnion'"
                            >
                                <div class="row">
                                    <div class="col-xl-3 col-md-3 col-12">
                                        <div class="form-group">
                                            <label for="transunion-address">TransUnion Address</label>
                                            <select
                                                v-model="creditBureaus['TransUnion'].selected_address"
                                                class="form-control"
                                                id="transunion-address"
                                                required
                                                @change="updateLetter()"
                                            >
                                                <option v-for="(address, value) in creditBureaus['TransUnion'].addresses" :value="address.id">
                                                    {{ address.street }}, {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-md-3 col-12">
                                        <label for="attach-document">Attach Document</label>
                                        <div style="padding-top: 18px;padding-bottom: 18px;" class="form-group display-box">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="append_affidavit"
                                                    name="append_affidavit"
                                                    value="1"
                                                    v-model="affidavit"
                                                />
                                                <label class="custom-control-label" for="append_affidavit">
                                                    ID Theft Affidavit
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <editor
                                    id="transUnion"
                                    v-model="letters.transUnion"
                                    :api-key="settingStore.tinymce.api_key"
                                    :init="settingStore.tinymce.configuration"
                                />
                            </div>
                            <div
                                v-if="
                                    reportStore.getSelectedAccounts(1, creditBureaus['Experian'].id).length > 0
                                    ||
                                    reportStore.getInquiries(1, 'Experian').length > 0
                                    ||
                                    reportStore.getSelectedAccounts(1, creditBureaus['Experian'].id, 'public-record').length > 0
                                "
                                v-show="activeTab == 'experian'"
                            >
                                <div class="row">
                                    <div class="col-xl-3 col-md-3 col-12">
                                        <div class="form-group">
                                            <label for="experian-address">Experian Address</label>
                                            <select
                                                v-model="creditBureaus['Experian'].selected_address"
                                                class="form-control"
                                                id="experian-address"
                                                required
                                                @change="updateLetter()"
                                            >
                                                <option v-for="(address, value) in creditBureaus['Experian'].addresses" :value="address.id">
                                                    {{ address.street }}, {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-md-3 col-12">
                                        <label for="attach-document">Attach Document</label>
                                        <div style="padding-top: 18px;padding-bottom: 18px;" class="form-group display-box">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="append_affidavit"
                                                    name="append_affidavit"
                                                    value="1"
                                                    v-model="affidavit"
                                                />
                                                <label class="custom-control-label" for="append_affidavit">
                                                    ID Theft Affidavit
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <editor
                                    id="experian"
                                    v-model="letters.experian"
                                    :api-key="settingStore.tinymce.api_key"
                                    :init="settingStore.tinymce.configuration"
                                />
                            </div>
                            <div
                                v-if="
                                    reportStore.getSelectedAccounts(1, creditBureaus['Equifax'].id).length > 0
                                    ||
                                    reportStore.getInquiries(1, 'Equifax').length > 0
                                    ||
                                    reportStore.getSelectedAccounts(1, creditBureaus['Equifax'].id, 'public-record').length > 0
                                "
                                v-show="activeTab == 'equifax'"
                            >
                                <div class="row">
                                    <div class="col-xl-3 col-md-3 col-12">
                                        <div class="form-group">
                                            <label for="equifax-address">
                                                Equifax Address
                                            </label>
                                            <select
                                                v-model="creditBureaus['Equifax'].selected_address"
                                                class="form-control"
                                                id="equifax-address"
                                                required
                                                @change="updateLetter()"
                                            >
                                            <option v-for="(address, value) in creditBureaus['Equifax'].addresses" :value="address.id">
                                                {{ address.street }}, {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
                                            </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-md-3 col-12">
                                        <label for="attach-document">Attach Document</label>
                                        <div style="padding-top: 18px;padding-bottom: 18px;" class="form-group display-box">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="append_affidavit"
                                                    name="append_affidavit"
                                                    value="1"
                                                    v-model="affidavit"
                                                />
                                                <label class="custom-control-label" for="append_affidavit">
                                                    ID Theft Affidavit
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <editor
                                    id="equifax"
                                    v-model="letters.equifax"
                                    :api-key="settingStore.tinymce.api_key"
                                    :init="settingStore.tinymce.configuration"
                                />
                            </div>
                        </div>
                        <div ref="transUnion" hidden>
                            <span v-html="dynamicComponent(creditBureaus['TransUnion'])" :key="creditBureaus['TransUnion'].selected_address"></span>
                        </div>
                        <div ref="experian" hidden>
                            <span v-html="dynamicComponent(creditBureaus['Experian'])" :key="creditBureaus['Experian'].selected_address" ></span>
                        </div>
                        <div ref="equifax" hidden>
                            <span v-html="dynamicComponent(creditBureaus['Equifax'])" :key="creditBureaus['Equifax'].selected_address"></span>
                        </div>
                    </div>
                </div>
                <div v-else class="card-body">
                    <div class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                        <div class="alert-body">
                            <i data-feather="info" class="mr-50 align-middle"></i>
                            <span>
                                {{ localizationStore.translate("error.filter.update") }}
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="letterStore.RECIPIENT.FURNISHER == letter.recipient">
                <div v-if="reportStore.filterDataFurnishers(1).length > 0" class="card-body">
                    <ul class="nav nav-tabs nav-justified" role="tablist">
                        <li v-for="(furnisher, key) in dataFurnishers" :ref="furnisher.ref" class="nav-item">
                            <a
                                class="nav-link"
                                :class="{ active: activeTab == key}"
                                @click="activeTab = key"
                            >
                                {{ furnisher.furnisher.name }}
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content pt-1">
                        <div
                            class="tab-pane active"
                            role="tabpanel"
                        >
                            <div class="row">
                                <div class="col-12">
                                    <h4>APPEND CLIENT DOCUMENTS</h4>
                                    <div class="display-box mb-1">
                                        <div class="ml-2">
                                            <input
                                                class="custom-control-input"
                                                type="checkbox"
                                                value="1"
                                                v-model="affidavit"
                                                id="affidavit"
                                            />
                                            <label class="custom-control-label" for="affidavit">
                                                ID Theft Affidavit
                                            </label>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div v-for="(furnisher, key) in dataFurnishers" v-show="activeTab == key">
                                <editor
                                    :id="key"
                                    v-model="furnisher.ref"
                                    :api-key="settingStore.tinymce.api_key"
                                    :init="settingStore.tinymce.configuration"
                                />
                            </div>
                        </div>
                        <div v-for="dataFurnisherRef in dataFurnisherRefs" :ref="dataFurnisherRef" hidden>
                            <span v-html="dynamicComponent(creditBureaus['TransUnion'], dataFurnishers[dataFurnisherRef].furnisher)"></span>
                        </div>
                    </div>
                </div>
                <div v-else class="card-body">
                    <div class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                        <div class="alert-body">
                            <i data-feather="info" class="mr-50 align-middle"></i>
                            <span>
                                {{ localizationStore.translate("error.data.furnishers") }}
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="letterStore.RECIPIENT.CREDITOR == letter.recipient">
                <div v-if="creditorRefs.length > 0" class="card-body">
                    <ul class="nav nav-tabs nav-justified" role="tablist">
                        <li v-for="(creditor, key) in creditors" :ref="creditor.ref" class="nav-item">
                            <a
                                class="nav-link"
                                :class="{ active: activeTab == key}"
                                @click="activeTab = key"
                            >
                                {{ creditor.creditor.creditor_name }}
                            </a>
                        </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content pt-1">
                        <div
                            class="tab-pane active"
                            role="tabpanel"
                        >
                            <div class="row">
                                <div class="col-12">
                                    <h4>APPEND CLIENT DOCUMENTS</h4>
                                    <div class="display-box mb-1">
                                        <div class="ml-2">
                                            <input
                                                class="custom-control-input"
                                                type="checkbox"
                                                value="1"
                                                v-model="affidavit"
                                                id="affidavit"
                                            />
                                            <label class="custom-control-label" for="affidavit">
                                                ID Theft Affidavit
                                            </label>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div v-for="(creditor, key) in creditors" v-show="activeTab == key">
                                <editor
                                    :id="key"
                                    v-model="creditor.ref"
                                    :api-key="settingStore.tinymce.api_key"
                                    :init="settingStore.tinymce.configuration"
                                />
                            </div>
                        </div>
                        <div v-for="creditorRef in creditorRefs" :ref="creditorRef" hidden>
                            <span v-html="dynamicComponent(creditBureaus['TransUnion'], null, creditors[creditorRef])"></span>
                        </div>
                    </div>
                </div>
                <div v-else class="card-body">
                    <div class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                        <div class="alert-body">
                            <i data-feather="info" class="mr-50 align-middle"></i>
                            <span>
                                {{ localizationStore.translate("error.creditors") }}
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            <div class="col-md-6">
                <button class="btn btn-primary m-1" type="button" @click.once="createLetter()">Create Letter</button>
            </div>
        </div>
    </div>
</template>
<script>
  import { reactive, ref, computed, render, h } from 'vue'
  import { useUserStore } from '../../stores/UserStore.js'
  import { useLetterStore } from '../../stores/LetterStore.js'
  import { useLocalizationStore } from '../../stores/LocalizationStore.js';
  import { useSettingStore } from '../../stores/SettingStore.js'
  import {useReportStore} from '../../stores/ReportStore.js'
  import Select2 from 'vue3-select2-component'
  import Editor from '@tinymce/tinymce-vue'
  import moment from 'moment';
  import { parse } from 'node-html-parser';
  export default {
    props: {
        letter: {
            type: [Array, Object]
        },
        creditBureaus: {
            type: [Array, Object]
        },
    },
    components: {
        editor:Editor,
        Select2
    },
    setup(props) {
        const editorRef = ref(null);
        let creditBureaus = [];
        _.forEach(props.creditBureaus, function(creditBureau) {
            creditBureaus[_.get(creditBureau, 'name')] = creditBureau;
        });
        return {
            creditBureaus: reactive(creditBureaus),
            affidavit: ref(false),
            activeTab: ref('transUnion'),
            editorRef,
            content: ref(null),
            creditors: reactive({}),
            creditorRefs: reactive([]),
            moment:moment,
            userStore:useUserStore(),
            letters: reactive({
                transUnion: null,
                experian: null,
                equifax: null,
            }),
            letterStore: useLetterStore(),
            localizationStore: useLocalizationStore(),
            settingStore: useSettingStore(),
            reportStore:useReportStore(),
            dataFurnishers: reactive({}),
            dataFurnisherRefs: reactive([]),
        };
    },
    watch:{
        'userStore.user'(value) {
            if (value != null) {
                if (!this.reportStore.reports[this.userStore.user.email]) {
                    this.reportStore.getReport();
                }
            }
        }
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            const $this = this;
            _.forEach($this.$refs, function(ref, key) {
                if (_.has($this.dataFurnishers, key)) {
                    $this.dataFurnishers[key].ref = ref[0].innerHTML;
                }
                if (_.has($this.creditors, key)) {
                    $this.creditors[key].ref = ref[0].innerHTML;
                }
            });
        });
        const $this = this;
        _.forOwn($this.creditBureaus, function(creditBureau) {
            if ($this.reportStore.getSelectedAccounts(1, creditBureau.id).length > 0) {
                $this.activeTab = _.camelCase(creditBureau.name);
                return false;
            }
            if ($this.reportStore.getInquiries(1, creditBureau.name).length > 0) {
                $this.activeTab = _.camelCase(creditBureau.name);
                return false;
            }
            if ($this.reportStore.getSelectedAccounts(1, creditBureau.id, 'public-record').length > 0) {
                $this.activeTab = _.camelCase(creditBureau.name);
                return false;
            }
        });
        _.forEach($this.reportStore.filterDataFurnishers(1), function(dataFurnisher) {
            let furnisherName = dataFurnisher.name;
            if (furnisherName) {
                furnisherName = _.camelCase(furnisherName);
                $this.dataFurnisherRefs.push(furnisherName);
                if (_.isUndefined($this.dataFurnishers[furnisherName])) {
                    $this.dataFurnishers[furnisherName] = {
                        furnisher: dataFurnisher,
                        ref: null
                    };
                }
            }
        });
        _.forEach(this.reportStore.getSelectedCreditorAccounts(), function(creditor) {
            let furnisherName = $this.reportStore.getCreditorDetail(creditor[4].creditor).creditor_name;
            if (furnisherName) {
                furnisherName = _.camelCase(furnisherName);
                $this.creditorRefs.push(furnisherName);
                if (_.isUndefined($this.creditors[furnisherName])) {
                    $this.creditors[furnisherName] = {
                        accounts: [],
                        creditor: $this.reportStore.getCreditorDetail(creditor[4].creditor),
                        ref: null
                    };
                    let accountDetail = $this.reportStore.getAccountDetail(creditor);
                    accountDetail.reason = creditor[4].reason;
                    $this.creditors[furnisherName].accounts.push(accountDetail);
                }
                else {
                    let accountDetail = $this.reportStore.getAccountDetail(creditor);
                    accountDetail.reason = creditor[4].reason;
                    $this.creditors[furnisherName].accounts.push(accountDetail);
                }
            }
        });
        if ($this.letterStore.RECIPIENT.FURNISHER == $this.letter.recipient) {
            $this.activeTab = _.head($this.dataFurnisherRefs);
        }
        else if ($this.letterStore.RECIPIENT.CREDITOR == $this.letter.recipient) {
            $this.activeTab = _.head($this.creditorRefs);
        }
        $this.letters.transUnion = $this.$refs.transUnion?.innerHTML;
        $this.letters.experian = $this.$refs.experian?.innerHTML;
        $this.letters.equifax = $this.$refs.equifax?.innerHTML;
    },
    computed: {
        dynamicComponent() {
            let $this = this;
            return function (creditBureau, dataFurnisher = null, creditor = null) {
                let accountList = '', accounts = [];
                if ($this.letterStore.RECIPIENT.CREDITOR == $this.letter.recipient) {
                    accounts = creditor.accounts;
                }
                else if ($this.letterStore.RECIPIENT.FURNISHER == $this.letter.recipient) {
                    _.forEach($this.reportStore.getSelectedCreditorAccounts(), function(creditor) {
                        let accountDetail = $this.reportStore.getAccountDetail(creditor);
                        accountDetail.reason = creditor[4].reason;
                        accounts.push(accountDetail);
                    });
                }
                else {
                    accounts = $this.reportStore.getSelectedAccounts(1, creditBureau.id);
                }
                _.forEach(accounts, function(account) {
                    accountList += `<p>
                        <strong>
                            ${ account.furnisher_name }
                        </strong>
                        <br />
                        Account Number: ${ account.account_number }
                        <br />
                        ${account.reason}
                    </p>`;
                });
                let inquiryList = '', inquiries = [];
                if (
                    $this.letterStore.RECIPIENT.CREDITOR == $this.letter.recipient
                    ||
                    $this.letterStore.RECIPIENT.FURNISHER == $this.letter.recipient
                ) {
                    inquiries = $this.reportStore.getInquiries(1);
                }
                else {
                    inquiries = $this.reportStore.getInquiries(1, creditBureau.name);
                }
                _.forEach(inquiries, function(inquiry, iteration) {
                    let reason = inquiry?.reason;
                    inquiryList += `<p>
                        ${ inquiry.creditor_name },
                        <br />
                        Date of inquiry: ${ inquiry.date_of_inquiry }
                        <br />
                        ${inquiry.reason}
                    </p>`;
                });
                let publicRecordList = '', publicRecords = [];
                if (
                    $this.letterStore.RECIPIENT.CREDITOR == $this.letter.recipient
                    ||
                    $this.letterStore.RECIPIENT.FURNISHER == $this.letter.recipient
                ) {
                    publicRecords = $this.reportStore.getSelectedAccounts(1, 'all', 'public-record');
                }
                else {
                    publicRecords = $this.reportStore.getSelectedAccounts(1, creditBureau.id, 'public-record');
                }
                _.forEach(publicRecords, function(publicRecord) {
                    publicRecordList += `<strong>"${ publicRecord.type }"</strong>with<strong> Reference#: ${ publicRecord.reference_number }</strong>.<br />${publicRecord.reason}`;
                });
                let identityImageUrl = $this.userStore?.user?.identity_image_url;
                if (identityImageUrl) {
                    identityImageUrl = `<img src='${identityImageUrl}' width='400' /><br />`;
                }
                let addressVerifyImageUrl = $this.userStore?.user?.address_verify_image_url;
                if (addressVerifyImageUrl) {
                    addressVerifyImageUrl = `<img src='${addressVerifyImageUrl}' width='400' /><br />`;
                }
                let ssnImageUrl = $this.userStore?.user?.ssn_image_url;
                if (ssnImageUrl) {
                    ssnImageUrl = `<img src='${ssnImageUrl}' width='400' /><br />`;
                }
                // const template = parse($this.letter.letter_preview);
                // template.querySelectorAll('.remove').forEach((htmlElement) => { htmlElement.set_content(""); });
                const address = _.find(creditBureau.addresses, { 'id': creditBureau.selected_address });
                const data = {
                    '{{ first_name }}': $this.userStore.user.firstname,
                    '{{ middle_name }}': $this.userStore.user.middle_name,
                    '{{ last_name }}': $this.userStore.user.lastname,
                    '{{ address }}': $this.userStore.user.address,
                    '{{ email }}': $this.userStore.user.email,
                    '{{ city }}': $this.userStore.user.city,
                    '{{ state }}': $this.userStore.user.state_abbreviation,
                    '{{ zipcode }}': $this.userStore.user.zipcode,
                    '{{ bdate }}': $this.userStore.user.dob,
                    '{{ ss_number }}': $this.userStore.user.ssn,
                    '{{ t_no }}': $this.userStore.user.phone,
                    '{{ driver_licence_or_state_id }}': identityImageUrl,
                    '{{ social_security_card }}': ssnImageUrl,
                    '{{ address_verification }}': addressVerifyImageUrl,
                    '{{ bureau_name }}': creditBureau.name,
                    '{{ bureau_address }}': address.street,
                    '{{ bureau_city }}': address.city,
                    '{{ bureau_state }}': address.state_abbreviation,
                    '{{ bureau_zipcode }}': address.zipcode,
                    '{{ curr_date }}': $this.userStore.user.tdate,
                    '{{ creditor_name }}': creditor?.creditor?.creditor_name,
                    '{{ creditor_address }}': creditor?.creditor?.address,
                    '{{ creditor_phone }}': creditor?.creditor?.phone,
                    '{{ creditor_city }}': creditor?.creditor?.city,
                    '{{ creditor_state }}': creditor?.creditor?.state,
                    '{{ creditor_zip }}': creditor?.creditor?.zipcode,
                    '{{ account_number }}': "account_number",
                    '{{ furnisher_name }}': dataFurnisher?.name,
                    '{{ furnisher_address }}': dataFurnisher?.address_name,
                    '{{ furnisher_street_address }}': dataFurnisher?.street_address,
                    '{{ furnisher_city }}': dataFurnisher?.city,
                    '{{ furnisher_state }}': dataFurnisher?.state_abbrev,
                    '{{ furnisher_zipcode }}': dataFurnisher?.zipcode,
                    '{{ account_type }}': "type",
                    '{{ account_late_status }}': "late_status",
                    '{{ date_of_inquiry }}': 'date_of_inquiry',
                    '{{ account_list }}': accountList,
                    '{{ inquiry_list }}': inquiryList,
                    '{{ public_record_list }}': publicRecordList,
                };
                let html = $this.letter.letter_preview;
                _.forEach(data, function(value, key) {
                    if (html.includes(key)) {
                        html = html.replace(new RegExp(key, 'g'), (_.isNull(value) ? '' : value));
                    }
                })
                return html;
            };
        }
    },
    methods: {
        createLetter: function(){
            let $this = this;
            const createLetterRoute = this.$router.resolve({
                name: 'create-letter',
                params: {
                    client: this.$route.params.client,
                    letter: this.$route.params.letter,
                    team: this.$route.params.team,
                }
            });
            let payload = {
                multipe_letters: true,
                letters: []
            };
            if ($this.letterStore.RECIPIENT.BUREAU == $this.letter.recipient) {
                _.forOwn($this.creditBureaus, function(creditBureau) {
                    if (
                        $this.reportStore.getSelectedAccounts(1, creditBureau.id).length > 0
                    ) {
                        let accounts = [];
                        _.forEach($this.reportStore.getSelectedAccounts(1, creditBureau.id), function(account) {
                            accounts.push({
                                'id': account.id,
                                'reason': account.reason
                            });
                        });
                        payload.letters.push({
                            letter_slug: $this.$route.params.letter,
                            credit_bureau_name: creditBureau.name,
                            letter_preview: tinymce.get(_.camelCase(creditBureau.name)).getContent(),
                            accounts: accounts,
                            append_affidavit : $this.affidavit,
                            addressable_id: creditBureau.selected_address,
                        });
                    }
                });
            }
            else if ($this.letterStore.RECIPIENT.FURNISHER == $this.letter.recipient) {
                _.forEach($this.dataFurnishers, function(furnisher) {
                    payload.letters.push({
                        letter_slug: $this.$route.params.letter,
                        credit_bureau_name: furnisher.furnisher.name,
                        letter_preview: furnisher.ref,
                        append_affidavit : $this.affidavit,
                    });
                });   
            }
            else if ($this.letterStore.RECIPIENT.CREDITOR == $this.letter.recipient) {
                _.forEach($this.creditors, function(creditor) {
                    let accounts = [];
                    _.forEach(creditor.accounts, function(account) {
                        accounts.push({
                            'id': account.id,
                            'reason': account.reason
                        });
                    });
                    payload.letters.push({
                        letter_slug: $this.$route.params.letter,
                        credit_bureau_name: creditor.creditor.creditor_name,
                        letter_preview: creditor.ref,
                        accounts: accounts,
                        append_affidavit: $this.affidavit,
                    });
                });
            }
            axios.post(createLetterRoute.href, payload)
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    if($this.userStore.user.isDIY){
                        $this.$router.push({ name: 'disputes-report' });
                        return;
                    }
                    $this.$router.push({ name: 'report', params: $this.$route.params });
                }, 3000)
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        updateLetter() {
            this.letters.transUnion = this.$refs.transUnion.innerHTML;
            this.letters.experian = this.$refs.experian.innerHTML;
            this.letters.equifax = this.$refs.equifax.innerHTML;
        },
    },
  };
</script>
